import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import PropTypes from 'prop-types';

const Checkbox = ({ classes, i, error, onChange, value, mode }) => {
  const { field, label, options, noOptionsMessage, direction, disabledOnEdit, validate } = i;

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error}
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: direction === 'vertical' ? 'column' : 'row',
          // alignItems: 'center',
          flexWrap: 'wrap',
          // width: '50%',
        }}
      >
        {options.map((opt, optIdx) => {
          return (
            <div
              key={`${field}_checkbox_${opt.value}_${optIdx}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginRight: 20,
              }}
              // onClick={() => {
              //   const found = value && value.includes(opt.value);
              //   let tempValue = []
              //   if (found) {
              //     tempValue = value.filter(v => v !== opt.value);
              //   } else {
              //     tempValue = value.concat(opt.value);
              //   }
              //   onChange(i.field, tempValue, treeTrace);
              // }}
            >
              <input
                type="checkbox"
                checked={value && value.includes(opt.value)}
                style={{ marginRight: 10 }}
                value={opt.value}
                disabled={disabledOnEdit && mode === 'EDIT'}
                className={cn(
                  classes.input,
                  classes.checkboxInput,
                  error && classes.textInputError,
                  disabledOnEdit && mode === 'EDIT' && classes.disabledInput,
                )}
                {...i}
              />
              <span>{opt.label}</span>
            </div>
          );
        })}
      </div>
      {noOptionsMessage && !options.length && <div style={{ color: '#777', fontSize: 12 }}>{noOptionsMessage}</div>}
    </div>
  );
};

Checkbox.propTypes = {
  treeTrace: PropTypes.arrayOf(PropTypes.object),
  errors: PropTypes.object,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  i: PropTypes.shape({
    field: PropTypes.string.isRequired,
    label: PropTypes.string,
    validate: PropTypes.array,
    options: PropTypes.array.isRequired,
    direction: PropTypes.oneOf(['vertical', 'horizontal']),
  }),
};

Checkbox.defaultProps = {
  treeTrace: [],
  errors: {},
  data: {},
  extraIndexForKey: 0,
  onChange: () => {},
  numberOfChildren: 0,
  i: {
    direction: 'horizontal',
  },
};

export default withStyles(styles)(Checkbox);
